import { FILTER_KEYS } from '@/utils/consts';
import { OPERATOR } from '@/components/Dashboard/common/Filter/const';

const {
    TITLE,
    STATUS,
    CHANNEL,
    ID,
    AD_ACCOUNT_ID,
    UTM,
    LABEL,
    OS,
    OBJECTIVE,
    GENERIC,
} = FILTER_KEYS;

export const TITLE_LEVEL = {
    AD_ACCOUNT: 'adAccount',
    CAMPAIGN: 'campaign',
    ADSET: 'adSet',
    AD: 'ad',
};

export const STATUS_LEVEL = {
    CAMPAIGN: 'campaign',
    ADSET: 'adSet',
    AD: 'ad',
    KEYWORD: 'keyword',
};

export const STATUS_VALUES = {
    ACTIVE: 'active',
    IN_REVIEW: 'in_review',
    DISAPPROVED: 'disapproved',
    DEACTIVATED: 'deactivated',
    DELETED: 'deleted',
    SCHEDULED: 'scheduled',
};

export const ID_LEVEL = {
    CAMPAIGN: 'campaign',
    ADSET: 'adSet',
    AD: 'ad',
};

export const METRIC_LEVEL = {
    CLICKS: 'clicks',
    IMPRESSIONS: 'impressions',
    SPEND: 'spend',
    CPC: 'cpc',
};

export const UTM_LEVEL = {
    SOURCE: 'source',
    CAMPAIGN: 'campaign',
    MEDIUM: 'medium',
    CONTENT: 'content',
    TERM: 'term',
};

export const OS_VALUES = {
    ANDROID: 'android',
    iOS: 'ios',
    DESKTOP: 'desktop',
    OTHERS: 'others',
    unknown: 'unknown',
};

export const FIELD_OPTIONS = {
    [TITLE]: { level: TITLE_LEVEL },
    [STATUS]: { level: STATUS_LEVEL, value: STATUS_VALUES },
    [CHANNEL]: {},
    [ID]: { level: ID_LEVEL },
    [AD_ACCOUNT_ID]: {},
    [UTM]: { level: UTM_LEVEL },
    [LABEL]: {},
    [OS]: { value: OS_VALUES },
    [OBJECTIVE]: {},
    [GENERIC]: {},
};

export const DATASTREAM_FIELD_OPTIONS = {
    [TITLE]: { level: TITLE_LEVEL },
    [STATUS]: { level: STATUS_LEVEL, value: STATUS_VALUES },
    [CHANNEL]: {},
    [ID]: { level: ID_LEVEL },
    [OBJECTIVE]: {},
};

export const OPERATOR_LIST_TYPES = {
    IN: {
        in: OPERATOR.in,
    },
    INS: {
        in: OPERATOR.in,
        notIn: OPERATOR.notIn,
    },
    LIKES: {
        in: OPERATOR.in,
        notIn: OPERATOR.notIn,
        like: OPERATOR.like,
        notLike: OPERATOR.notLike,
    },
    INLIKE: {
        in: OPERATOR.in,
        like: OPERATOR.like,
    },
    STARTS: {
        in: OPERATOR.in,
        notIn: OPERATOR.notIn,
        like: OPERATOR.like,
        notLike: OPERATOR.notLike,
        startsWith: OPERATOR.startsWith,
        endsWith: OPERATOR.endsWith,
    },
    ALL: OPERATOR,
};

export const DEFAULT_OPERATOR_MAP = {
    [TITLE]: OPERATOR.like,
    [STATUS]: OPERATOR.in,
    [CHANNEL]: OPERATOR.in,
    [ID]: OPERATOR.like,
    [AD_ACCOUNT_ID]: OPERATOR.in,
    [UTM]: OPERATOR.like,
    [LABEL]: OPERATOR.in,
    [OS]: OPERATOR.in,
    [OBJECTIVE]: OPERATOR.in,
    [GENERIC]: OPERATOR.in,
};

// brekadown can be changed
export const OPERATOR_LIST_MAP = {
    [TITLE]: OPERATOR_LIST_TYPES.LIKES,
    [STATUS]: OPERATOR_LIST_TYPES.INS,
    [CHANNEL]: OPERATOR_LIST_TYPES.INS,
    [ID]: OPERATOR_LIST_TYPES.LIKES,
    [AD_ACCOUNT_ID]: OPERATOR_LIST_TYPES.INS,
    [UTM]: OPERATOR_LIST_TYPES.LIKES,
    [LABEL]: OPERATOR_LIST_TYPES.IN,
    [OS]: OPERATOR_LIST_TYPES.INS,
    [OBJECTIVE]: OPERATOR_LIST_TYPES.INS,
    [GENERIC]: OPERATOR_LIST_TYPES.ALL,
};

export const INPUT_TYPES = {
    INPUT: 'input',
    DROPDOWN: 'dropdown',
    DROPDOWN_INPUT: 'dropdownInput',
    DROPDOWN_CHECKBOX_INPUT: 'dropdownCheckboxInput',
};

export const VALUE_INPUT_TYPE_MAP = {
    [TITLE]: INPUT_TYPES.INPUT,
    [STATUS]: INPUT_TYPES.DROPDOWN,
    [CHANNEL]: INPUT_TYPES.DROPDOWN_CHECKBOX_INPUT,
    [ID]: INPUT_TYPES.INPUT,
    [AD_ACCOUNT_ID]: INPUT_TYPES.DROPDOWN_CHECKBOX_INPUT,
    [UTM]: INPUT_TYPES.INPUT,
    [LABEL]: INPUT_TYPES.DROPDOWN_INPUT,
    [OS]: INPUT_TYPES.DROPDOWN,
    [OBJECTIVE]: INPUT_TYPES.DROPDOWN,
    [GENERIC]: INPUT_TYPES.INPUT,
};

export const OBJECTIVE_DISCARD_OPTIONS = [
    'traffic',
    'rf_reach',
    'store_visits',
];
